/* eslint-disable no-unused-vars, valid-jsdoc */
/**
 * @typedef {callback} _
 * @param {?} currentValue
 * @param {Number=} index
 * @param {[]=} array
 * @returns {any}
 */
function callback(currentValue, index, array) {}

export default callback;
